import NewsLetterModal from './newsLetterModal';

export default NewsLetterModal;
